import {request} from './request'

const posterApi ={
  //列表
  getList:params => request({url: '/TPosterApi/GetList',params}),
  
  getActivityList: params => request({url: '/TPosterApi/GetListActivity', params}),

  //单一节目内容
  getOneById: params => request({url: '/TPosterApi/GetById', params }),
}

export default posterApi